class FlashcardQuestionResponseClass{
  constructor(config={}){
    config = config || {}; //if the config supplied is null and not undefined
    this.answerState = config.answerState || FlashcardQuestionResponseClass.ANSWER_STATE.OPEN;
    this.isCorrect = config.isCorrect || false;
    this.answer = config.answer || "";
    this.score = config.score || 0; //this is either score or negative score based on correct answer
    this.timeSpent = config.timeSpent || 0; //in seconds
    this.pastAttemptsCount = config.pastAttemptsCount || 0;
    this.pastAttempts = config.pastAttempts || [];
  }
  
  markAsAnswered(answer, isCorrect){
    this.answerState = FlashcardQuestionResponseClass.ANSWER_STATE.ANSWERED;
    if(typeof answer === "object"){
        this.answer = JSON.stringify(answer);
    }else{
        this.answer = answer;
    }
    this.isCorrect = isCorrect;
  }
  markAsTimedOut(){
    this.answerState = FlashcardQuestionResponseClass.ANSWER_STATE.TIMED_OUT;
    this.isCorrect = false;
  }
  setScore(score){
    this.score = score;
  }
  getScore(){
    return this.score;
  }
  setTimeSpent(timeInSeconds){
    this.timeSpent = timeInSeconds || 0;
  }
  getTimeSpent(){
    return this.timeSpent;
  }
  isAnswered(){
    return this.answerState !== FlashcardQuestionResponseClass.ANSWER_STATE.OPEN;
  }
  getAnswer(){
    try {
      return JSON.parse(this.answer);
    } catch (error) {
      return [this.answer];
    }
  }
  isTimedOut = () => {
    return this.answerState === FlashcardQuestionResponseClass.ANSWER_STATE.TIMED_OUT;
  }

  getTotalAttempts(){
    return this.pastAttemptsCount + (this.isAnswered() ? 1 : 0);
  }

  performReattempt(){
    //add current data to past attempts
    this.pastAttempts.push({
      answerState: this.answerState,
      isCorrect: this.isCorrect,
      score: this.score,
      timeSpent: this.timeSpent,
      answer: this.answer
    });
    this.pastAttemptsCount += 1;
    
    //reset the response
    this.answerState = FlashcardQuestionResponseClass.ANSWER_STATE.OPEN;
    this.isCorrect = false;
    this.score = 0;
    this.timeSpent = 0;
    this.answer = "";
  }


  static ANSWER_STATE = {
    OPEN: 1, //the user hasn't attended the question yet
    ANSWERED: 2, //user has given a response
    TIMED_OUT: 3 //user couldn't answer within the given time
  }
}

const FlashcardQuestionResponse = config => new FlashcardQuestionResponseClass(config);
export default FlashcardQuestionResponse;